import { useEffect } from "react";

import { reportError } from "../app/errors";

/**
 * Soft assertion for "should never happen" invariants encountered during
 * render. Returns whether `value` is non-nullish, and when it isn't, reports
 * `message` to error tracking (once) so the caller can bail out gracefully:
 *
 *     if (!useSoftAssert(thing, "Thing missing")) return null;
 *
 * Unlike `assert`, this does not throw. Call it inline in the condition so the
 * type narrowing applies to the checked value.
 */
export function useSoftAssert<T>(
  value: T,
  message: string,
): value is NonNullable<T> {
  const ok = value != null;

  useEffect(() => {
    if (!ok) {
      reportError(new Error(message));
    }
  }, [ok, message]);

  return ok;
}
